"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutDTO = exports.LoginDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
let LoginDTO = class LoginDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LoginDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "sessionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "galaUserId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "altUserId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isAltUserLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "altUserLoginAuthority", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Application session id, if applicable'),
    __metadata("design:type", String)
], LoginDTO.prototype, "sessionId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Gala user id represented in userId field on primary payload'),
    __metadata("design:type", String)
], LoginDTO.prototype, "galaUserId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Alternate user id represented in gameId field on primary payload'),
    __metadata("design:type", String)
], LoginDTO.prototype, "altUserId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Does this event pertain to alternate user id (e.g. game_id) login in lieu of Gala User ID login?'),
    __metadata("design:type", Boolean)
], LoginDTO.prototype, "isAltUserLogin", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('What is the authority for the alternate user id, if applicable?'),
    __metadata("design:type", String)
], LoginDTO.prototype, "altUserLoginAuthority", void 0);
LoginDTO = __decorate([
    (0, decorators_1.Describe)('A user logged in'),
    (0, decorators_1.Warning)(`Use other DTOs for registration`)
], LoginDTO);
exports.LoginDTO = LoginDTO;
let LogoutDTO = class LogoutDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LogoutDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "sessionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "galaUserId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "altUserId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isAltUserLogout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "altUserLoginAuthority", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Application session id, if applicable'),
    __metadata("design:type", String)
], LogoutDTO.prototype, "sessionId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Gala user id represented in userId field on primary payload, if applicable'),
    __metadata("design:type", String)
], LogoutDTO.prototype, "galaUserId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Alternate user id represented in gameId field on primary payload, if applicable'),
    __metadata("design:type", String)
], LogoutDTO.prototype, "altUserId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Does this event pertain to alternate user id (e.g. gameId) logout in lieu of Gala User ID logout?'),
    __metadata("design:type", Boolean)
], LogoutDTO.prototype, "isAltUserLogout", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('What is the authority for the alternate user id, if applicable?'),
    __metadata("design:type", String)
], LogoutDTO.prototype, "altUserLoginAuthority", void 0);
LogoutDTO = __decorate([
    (0, decorators_1.Describe)('User logged out')
], LogoutDTO);
exports.LogoutDTO = LogoutDTO;
